import styled from '@emotion/styled'
import { SvgIcon, SvgIconProps } from '@mui/material'

const StyledPath = styled.path`
  fill: ${(p) => p.theme.colors.bluishGrey};
`

const EmailIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24.825 17.141">
    <g>
      <StyledPath
        d="M10.364 973.362A2.372 2.372 0 0 0 8 975.727v12.412a2.372 2.372 0 0 0 2.364 2.364h20.1a2.372 2.372 0 0 0 2.364-2.364v-12.412a2.372 2.372 0 0 0-2.364-2.364zm0 1.182h20.1a1.215 1.215 0 0 1 .286.037l-9.863 9.54a.782.782 0 0 1-.942 0l-9.863-9.54a1.215 1.215 0 0 1 .282-.037zm-1.136.877l6.908 6.677-6.825 6.566a1.182 1.182 0 0 1-.129-.526v-12.411a1.2 1.2 0 0 1 .046-.305zm22.368 0a1.2 1.2 0 0 1 .046.3v12.412a1.182 1.182 0 0 1-.129.526l-6.825-6.559 6.908-6.677zm-14.61 7.5l2.124 2.05a1.882 1.882 0 0 0 2.6 0l2.124-2.05 6.649 6.4H10.337l6.649-6.4z"
        transform="translate(-8 -973.362)"
      />
    </g>
  </SvgIcon>
)

export default EmailIcon
